module.exports = __webpack_public_path__ + "static/img/qingdan.ea07804a.png";